import React from "react";
import Row from "../components/Row/Row";
import { api } from "../api/Api";
import Banner from "../components/Banner/Banner";
import SectionA from "./SectionA";

const DashBoard = () => {
  return (
    <div>
      <Banner />
      <Row
        title='NETFLIX ORIGINALS'
        fetchUrl={api.fetchNetflixOriginals}
        isLargeRow
      />
      <Row title='Trending Now' fetchUrl={api.fetchTrending} />
      <Row title='Action Movies' fetchUrl={api.fetchActionMovies} />
      <Row title='Comedy Movies' fetchUrl={api.fetchComedyMovies} />
      <Row title='Horror Movies' fetchUrl={api.fetchHorrorMovies} />
      <Row title='Documentries' fetchUrl={api.fetchDocumentries} />
      <SectionA />
    </div>
  );
};

export default DashBoard;
